module.exports = __webpack_public_path__ + "static/media/full.12e3ab3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/logo/full.png
// module id = 802
// module chunks = 0